<template>
    
    <nav class="navbar is-primary is-fixed-top"  role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
        <div class="navbar-item" >
              <div style="margin-left: 5px;display:inline-block">
                <s-button theme="is-warning " icon="times-circle" label="" @onclick="$emit('back')"/>
                <div style="padding-left:20px;font-size:13px;display:inline-block"> 
                <div class="g_mobileOn"  v-if="club!=null" >    
                                   
                    <div class="concours">{{club.name}}</div>
                    <div class="concours"> Concours {{formatDate(tournoi.date)}} à {{tournoi.heure}}</div>
                    <div class="concours" v-if="tournoi"> 
                        <s-fil :options="tournoi.options" />
                    </div>
                    </div>
               
              </div>
              <div style="padding-left:20px;font-size:13px;display:inline-block">
                <div class="g_desktopOn" >
                    
                    <div class="concours">{{club.name}} : Concours {{formatDate(tournoi.date)}} à {{tournoi.heure}}</div>
                    <div class="concours" v-if="tournoi"> 
                        <s-fil :options="tournoi.options" />
                    </div>
                    </div>
                
              </div>
              </div>
              <div  class="g_desktopOn titleTournoi">
                  {{title}}
              </div>
        </div>
        
        <a
            id="example-burger-progress"
            role="button"
            :class="classBurger+active"
            aria-label="menu"
            aria-expanded="false"
            data-target="main-menu-progress"
            v-on:click="activeBurger"
        >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <s-arrow id="Classement" v-if="active!='is-active'"/>
        </a>
        </div>

    <div id="main-menu-progress" :class="classMenuBurger+active"  >
      <div class="navbar-end">
        <div class="navbar-item"  v-if="tournoi.length!=0 && tournoi.options.mode=='ALEA'" v-show="display=='inscription'">      
           
            <s-button label="Réponses"
                theme="is-warning"
                icon="envelope-open-text"
                @onclick="modalInscriptionState=true" 
            /> 
                
        </div>       
        <div class="navbar-item"  v-if="tournoi.length!=0 && tournoi.options.mode=='ALEA'" v-show="display!='list'">      
           
            <s-button :label="tournoi.joueurs.length + ' joueurs  !' "
                theme="is-info"
                icon="users"
                :afterIcon="exception==1 ? 'exclamation-circle' : ''"
                @onclick="$emit('nav','list')" 
                :disabled="display=='inscription'"
            /> 
                
        </div>
        <div class="navbar-item"  v-if="tournoi.length!=0 && tournoi.options.mode=='FORME'" v-show="display!='list'">      
            <s-button :label="equipes.length + ' equipes' "
                theme="is-info"
                icon="users"
                :afterIcon="exception==1 ? 'exclamation-circle' : ''"
                @onclick="$emit('nav','list')" 
                :disabled="display=='inscription'"
            /> 
                
        </div>
        
         <div class="navbar-item" v-show="display!='resultat' && tournoi.state!='INSCRIPTION'">
          <s-button icon="trophy" label="Classement" theme="is-success" @onclick="resultat" 
        />&nbsp;
          
        </div>
        <div class="navbar-item" v-if="tournoi && isAdminSite" v-show="(display=='resultat' || display=='inprogress')">
            <s-button :theme="prepareExcel==0 ? 'is-info is-normal' : 'is-success is-loading'" 
                label="Télécharger" icon="file-excel"
                v-show="prepareExcel!=2 "
                
                @onclick="prepareDownload" />

            <s-modal
                :open="prepareExcel==2"
                @close="closeExcel"
                :close="true"
                title="Votre fichier est préparé pour le téléchargement"
            >
            <div style="text-align:center;width:100%" >
            <download-excel
                    :data   = "json_data"
                    :fields = "json_fields"
                    :before-finish   = "finishDownload"
            >
                   <s-button theme="is-info is-medium" 
                label="Télécharger les parties" icon="file-excel"
                afterIcon="file-download"
                 />
                   
                </download-excel>
            <download-excel
                    :data   = "json_data"
                    :fields = "json_fields"
                    :before-finish   = "finishDownload"
            >
            <hr/>
                   <s-button theme="is-success is-medium" 
                label="Télécharger les résultats" icon="file-excel"
                afterIcon="file-download"
                 />
                   
                </download-excel>
            </div>
            </s-modal>
         </div>
         <div class="navbar-item">
            &nbsp;
        </div> 
      </div>
    </div>
    <s-zoom :open="modalZoom" @close="modalZoom=false"/>
    <s-modal
        :open="modalPayment"
        :close="true"
        title="Achetez des crédits"
        @close="payment">
            <credit-vue :from="true"/>
    </s-modal>
    <inscription-state
        :club="club"
        :tournoi="tournoi"
        :joueurs="joueurs"
        :open="modalInscriptionState"
        @close="modalInscriptionState=false"

    />
    <waiting :open="modalWaiting"/>
        </nav>
    
</template>
<style scoped>
    .concours {
        font-weight: bolder;
    }
    @media screen and (max-width: 420px) {  
        .concours {
            font-size: 11px;
        }
    }
    .titleTournoi {
        position: fixed;
        right: 40px;
        color: white;
        font-size: 32px;
    }
</style>
<script>
import downloadExcel from 'vue-json-excel'
import firebase_api from "@/firebase/firebase_api"
import tournoi_fct from "@/firebase/tournoi"
import credit_fct from "@/firebase/credit"
import creditVue from "@/views/payment/checkout.vue"
import choiceDelay from "@/views/tournoi/list/choiceDelay.vue"
import inscriptionState from "@/views/tournoi/inscription/inscriptionState.vue"

export default {
    props: ["tournoi", "club", "role", "parties","display", "indexPartie","joueurs", "title"],
    components: {
        downloadExcel,
        creditVue,
        choiceDelay,
        inscriptionState
    },
    computed: {
      
        equipes: {
                get() {
                    var equipes=[];
                    this.tournoi.joueurs.forEach(joueur=>{
                        if (joueur.meneur) {
                            equipes.push(joueur);
                        }
                    })
                   
                    return equipes;
                }
        }
        ,
        
        isAdminSite: {
            get() {
                if (typeof(this.$store.getters.getUser.adminSite)!="undefined")
                    return this.$store.getters.getUser.adminSite
                else
                    return false;
            }
        },
        
        disabledProlonger: {
            get() {
                if (this.tournoi.expire==null)
                    return false;
                else {
                    if (this.eventDoc == null)
                        return false;
                    else 
                        return this.eventDoc.state == 0;
                }
            }
            
        },
        credit: {
            get() {
            
                    if (this.$store.getters.getCredit == null)
                    return 0;
                    else
                    return this.$store.getters.getCredit.credit
            }
        }
        ,
        exception: {
            get() {
                if (this.tournoi.length!=0) {
                    if (this.tournoi.joueurs.length == 0)
                        return 2;
                    else {
                        var reste ;
                        
                        if (this.tournoi.options.nbJoueursParEquipe==1) {
                             reste = this.tournoi.joueurs.length % 2;
                             if (reste == 0)
                                return 0;
                             else    
                                return 1;
                        }
                        else {
                            reste = this.tournoi.joueurs.length % (this.tournoi.options.nbJoueursParEquipe * 2);
                           
                            if (reste == 0) {
                                return 0;
                            }
                            else {
                                return 1;
                            }
                        }
                    }
                }
                else
                    return 0;
            }
        }
    },
    data() {
        return {
            modalInscriptionState: false,
          
            modalZoom: false,
            modalWaiting: false,
            modalJoueursInscrits: false,
            eventDoc :null,
            modalProlonger: false,
            classBurger : "navbar-burger burger",
            classMenuBurger : "navbar-menu",
            modalPayment: false,
            active: "",
            
            prepareExcel: 0,
            json_data: [],
            json_fields: {
                'Partie': 'partie',
                'NUMERO J1': 'J1',
                'NOM J1': 'NOMJ1',
                'NUMERO J2': 'J2',
                'NOM J2': 'NOMJ2',
                'NUMERO J3': 'J3',
                'NOM J3': 'NOMJ3',
                'SCORE J1J2': 'SCOREJ1J2',
                'NUMERO C1': 'C1',
                'NOM C1': 'NOMC1',
                'NUMERO C2': 'C2',
                'NOM C2': 'NOMC2',
                'NUMERO C3': 'C3',
                'NOM C3': 'NOMC3',
                'SCORE C1C2': 'SCOREC1C2'
            },
            json_meta: [
                [
                    {
                        'key': 'charset',
                        'value': 'utf-8'
                    }
                ]
            ],
            fil: null
        }

    },
    methods: {
        
        resultat() {
            
            if (this.tournoi.options.competition == 3)
                this.$emit('nav','resultatPool')
            else
                this.$emit('nav','resultat')
        },
        openModalJoueursInscrits() {
            this.modalJoueursInscrits = !this.modalJoueursInscrits;
            this.$emit("activeBuger");
        },
        initFil() {
             var fil = null;
                
                if (this.tournoi.length!=0) {
                    
                     if (this.tournoi.options.competition != null) {
                         switch (this.tournoi.options.competition) {
                             case 1: 
                                fil = "Classique";
                                break;
                            case 2:
                                fil = "Gagnant Gagnant";
                                break;
                            case 3:
                                fil = "Championnat";
                                break;
                         }
                    //fil = this.tournoi.options.competition==1 ? "Classique" : "Elimination";
                    if (this.tournoi.options.nbJoueursParEquipe != null) {
                        switch (this.tournoi.options.nbJoueursParEquipe) {
                            case 1:
                                fil += " / Individuel"
                                break;
                            case 2:
                                fil += " / Doublette"
                                break;
                            case 3: 
                                fil += " / Triplette";
                                break;
                        }
                    }
                    if (this.tournoi.options.mode != null) {
                        fil += this.tournoi.options.mode == "ALEA" ? " / Aléatoire" : " / Formée"
                    }
                   
                }   
                }
                
              this.fil = fil;
        },
        prolonger() {
            this.modalProlonger=!this.modalProlonger;
            this.$emit("activeBuger");
        },
        setDelay(delay) {
             var authID = this.$store.getters.getUser.authId;
            // voir comment on récupère pour le deleguate
            if (this.credit > 0) {
                credit_fct.object.add(null , delay, authID, event=>{
                    if (event) {
                        this.$bind("eventDoc",event);
                    }
                    tournoi_fct.object.prolonger(delay, this.club, this.tournoi, tournoi=> {
                        this.tournoi.options.delay = delay;
                        this.modalProlonger = false;
                        
                    })
                })
            }
        },
        payment: function() {
            this.modalPayment= ! this.modalPayment;
            this.$emit("activeBuger");
        },
        
        closeExcel() {
            this.$emit("activeBuger");
            this.prepareExcel=0;
        },
        activeBurger() {
            this.$emit("activeBuger");   
            if (this.active == '') {
                this.active = 'is-active';         
                
            }
            else    
                this.active = '';
        },
        
        
        formatDate(date) {
            var options = { year: "2-digit", month: "2-digit", day: "2-digit"};
            return (new Date(date)).toLocaleString("fr-Fr",options);
          },
       
        init_json_data() {
            this.prepareExcel = 1;
            var tab= [];
            this.$emit("activeBuger")   
            if (this.parties != null)
            this.parties.forEach((partie, id)=>{
                
                firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois")
                    .doc(this.tournoi.id).collection("parties").doc(partie[".key"]).collection("equipes").get().then(equipesDoc=>{
                    
                    equipesDoc.docs.forEach((equipeDoc, indexEquipe)=>{
                            var equipe = equipeDoc.data();
                            var ligne = {};
                            ligne.partie = partie[".key"];
                            if (equipe.joueurs.J1!=null) {
                                ligne.J1 = parseInt(equipe.joueurs.J1.numero)+1;
                                ligne.NOMJ1 = this.joueurs[equipe.joueurs.J1.numero].pseudo
                            }
                            if (equipe.joueurs.J2!=null) {
                                ligne.J2 = parseInt(equipe.joueurs.J2.numero)+1;
                                ligne.NOMJ2 = this.joueurs[equipe.joueurs.J2.numero].pseudo
                            }
                            if (equipe.joueurs.J3!=null) {
                                ligne.J3 = parseInt(equipe.joueurs.J3.numero)+1;
                                ligne.NOMJ3 = this.joueurs[equipe.joueurs.J3.numero].pseudo
                            }   
                            if (equipe.contre.J1!=null) {
                                ligne.C1 = parseInt(equipe.contre.J1.numero)+1;
                                ligne.NOMC1 = this.joueurs[equipe.contre.J1.numero].pseudo
                            }
                        if (equipe.contre.J2!=null) {
                                ligne.C2 = parseInt(equipe.contre.J2.numero)+1;
                                ligne.NOMC2 = this.joueurs[equipe.contre.J2.numero].pseudo
                            }
                            if (equipe.contre.J3!=null) {
                                ligne.C3 = parseInt(equipe.contre.J3.numero)+1;
                                ligne.NOMC3 = this.joueurs[equipe.contre.J3.numero].pseudo
                            }
                            
                            ligne.SCOREJ1J2 = equipe.score.joueurs;
                            ligne.SCOREC1C2 = equipe.score.contre;
                            tab.push(ligne);
                            if (indexEquipe ==  equipesDoc.docs.length-1) {
                                 this.prepareExcel = 2;
                                 this.json_data =  tab; 
                               
                            }
                                
                        })
                })
             })
           
        },
        prepareDownload() {
            this.init_json_data();
            
        },
        finishDownload() {
            this.$emit("activeBuger")   
             this.prepareExcel = 0;
        }
    },
    mounted() {
        this.initFil();
    }
  
}
</script>